// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Global styling for dialog components
 * Theming the approval-comment-dialog and other Dialog subclasses
 * to align with Omega design tokens and PWA styling.
 */

/* Approval Comment Dialog Theming */

approval-comment-dialog {
    --dialog-background-color: var(--omega-primary-foreground, #fff);
    --dialog-backdrop-color: rgba(0, 0, 0, 0.5);
    --dialog-border-color: var(--omega-divider-color, #dddddd);
    --dialog-text-color: var(--omega-text-default, #3e3f42);
    --dialog-title-color: var(--omega-text-header, #545454);
    --dialog-header-padding: 1rem 1.25rem;
    --dialog-content-padding: 1rem 1.25rem;
    --dialog-footer-padding: 0.75rem 1.25rem;
    --dialog-footer-gap: 0.5rem;
    --dialog-border-radius: 12px;
}

/* Dialog root element styling */

approval-comment-dialog::part(dialog) {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

/* Header and footer divider styling */

approval-comment-dialog::part(header),
approval-comment-dialog::part(footer) {
    background-color: var(--omega-white-100, #f5f5f5);
}

/* Title styling */

approval-comment-dialog::part(title) {
    color: var(--dialog-title-color);
    font-family: 'Roboto', sans-serif;
}

/* Content styling */

approval-comment-dialog::part(content) {
    color: var(--dialog-text-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/dialog-themes.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,oCAAoC;;AACpC;IACI,gEAAgE;IAChE,2CAA2C;IAC3C,0DAA0D;IAC1D,uDAAuD;IACvD,uDAAuD;IACvD,qCAAqC;IACrC,sCAAsC;IACtC,wCAAwC;IACxC,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA,gCAAgC;;AAChC;IACI,0CAA0C;AAC9C;;AAEA,sCAAsC;;AACtC;;IAEI,iDAAiD;AACrD;;AAEA,kBAAkB;;AAClB;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA,oBAAoB;;AACpB;IACI,+BAA+B;AACnC","sourcesContent":["/**\n * Global styling for dialog components\n * Theming the approval-comment-dialog and other Dialog subclasses\n * to align with Omega design tokens and PWA styling.\n */\n\n/* Approval Comment Dialog Theming */\napproval-comment-dialog {\n    --dialog-background-color: var(--omega-primary-foreground, #fff);\n    --dialog-backdrop-color: rgba(0, 0, 0, 0.5);\n    --dialog-border-color: var(--omega-divider-color, #dddddd);\n    --dialog-text-color: var(--omega-text-default, #3e3f42);\n    --dialog-title-color: var(--omega-text-header, #545454);\n    --dialog-header-padding: 1rem 1.25rem;\n    --dialog-content-padding: 1rem 1.25rem;\n    --dialog-footer-padding: 0.75rem 1.25rem;\n    --dialog-footer-gap: 0.5rem;\n    --dialog-border-radius: 12px;\n}\n\n/* Dialog root element styling */\napproval-comment-dialog::part(dialog) {\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n\n/* Header and footer divider styling */\napproval-comment-dialog::part(header),\napproval-comment-dialog::part(footer) {\n    background-color: var(--omega-white-100, #f5f5f5);\n}\n\n/* Title styling */\napproval-comment-dialog::part(title) {\n    color: var(--dialog-title-color);\n    font-family: 'Roboto', sans-serif;\n}\n\n/* Content styling */\napproval-comment-dialog::part(content) {\n    color: var(--dialog-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
